import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['notificationEmailForm'];

  static values = { isPrivateGroup: Boolean };

  connect() {
    this.toggleNotificationEmailInput(this.isPrivateGroupValue);
  }

  toggleNotificationInput(evt) {
    const isPrivateGroup = evt.target.value === 'true';
    this.toggleNotificationEmailInput(isPrivateGroup);
  }

  toggleNotificationEmailInput(isPrivateGroup) {
    if (isPrivateGroup) {
      this.enableNotificationEmail();
    } else {
      this.disableNotificationEmail();
    }
  }

  enableNotificationEmail() {
    this.notificationEmailFormTarget.classList.remove('hidden');
  }

  disableNotificationEmail() {
    this.notificationEmailFormTarget.classList.add('hidden');
    this.notificationEmailFormTarget.value = null;
  }
}
